<template>
  <div class="donload_box">
    <van-overlay :show="download_show" @click="returnEvent">
      <div class="download" @click.stop>
        <div class="download_btn" @click="toDonload">下载噗噗小圈APP</div>
        <div class="return_btn" @click="returnEvent">返回</div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
// @ is an alias to /src
import { Overlay } from "vant";

export default {
  props: {
    //此处一定要用value
    value: {
      type: Boolean
    }
  },
  name: "home",
  components: {
    [Overlay.name]: Overlay
  },
  data() {
    return {
      download_show: this.value
    };
  },

  methods: {
    toDonload() {
      this.$bridge.callmethod("launchBox", {}, function() {});
    },

    returnEvent() {
      this.$emit("closepop");
    }
  }
};
</script>

<style scoped>
@import "../assets/common.css";
</style>
